import RelatedPathways from '@/components/related-pathways'
import { serviceLinkMatrix } from '@/constants/service-link-matrix'

export default function ServiceRelatedLinks({ path }) {
  const links = serviceLinkMatrix[path]
  if (!links) return null

  return <RelatedPathways title="Related Services" description={null} links={links} showBorders={false} noBottomPadding className="pb-4" />
}
